import { axios } from "utilities/axios";
import Axios from "axios";
import { Route } from "@edgetier/watchtower-types";

import { showServerError } from "utilities/show-server-error";

/**
 * When the user signs out the backend must delete the HTTP-only refresh token.
 */
export const deleteRefreshToken = async () => {
    try {
        await axios.delete(Route.TokensRefresh);
    } catch (serverError) {
        if (Axios.isAxiosError(serverError)) {
            showServerError(serverError);
        }
    }
};
